import * as React from 'react';
import { REPORT_TYPE_SERVER_TO_CLIENT_MAPPING } from '../../../../../../consts/report';
import { Tournament } from '../../../../../../models/tournament';
import { TournamentReportOptionsForm } from '../TournamentReportOptionsForm';
interface Props {
  onCloseClick: () => void;
  onSubmit: (data: any, reportType: string) => void;
  tournament: Tournament;
}
export function TournamentSchoolsReportForm(props: Props) {
  return (
    <TournamentReportOptionsForm
      {...props}
      reportType={REPORT_TYPE_SERVER_TO_CLIENT_MAPPING.TOURNAMENT_SCHOOLS}
      description="View schools booked onto the selected tournament and their administrator details."
      options={[
        {
          field: 'isShowAllAdmins',
          label: 'Show all school administrators',
          hint: 'Include every school user with the Admin role.',
          initialValue: false
        }
      ]}
    />
  );
}
